/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Doors_SubtitleInputs */

const en_simple_doors_subtitle = /** @type {(inputs: Simple_Doors_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three routes, one outcome: an app other people can open on their phone.`)
};

const id_simple_doors_subtitle = /** @type {(inputs: Simple_Doors_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga jalur, satu hasil yang sama: aplikasi yang bisa dibuka orang lain di HP.`)
};

/**
* | output |
* | --- |
* | "Three routes, one outcome: an app other people can open on their phone." |
*
* @param {Simple_Doors_SubtitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_doors_subtitle = /** @type {((inputs?: Simple_Doors_SubtitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Doors_SubtitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_doors_subtitle(inputs)
	return en_simple_doors_subtitle(inputs)
});